import { useState } from 'react';
import { Field, errorMessage } from '../components/ui.js';
import { useAuth } from '../lib/auth.js';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (caught) {
      setError(errorMessage(caught));
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-glow" aria-hidden="true" />
      <form className="card login-card" onSubmit={submit}>
        <div className="login-head">
          <div className="brand-mark" aria-hidden="true">
            M
          </div>
          <h2>Manasil Studio</h2>
          <p className="muted" style={{ fontSize: 13 }}>
            Sign in to manage the catalogue
          </p>
        </div>

        <div className="stack" style={{ gap: 14 }}>
          {error ? <div className="banner">{error}</div> : null}

          <Field label="Email">
            <input
              className="input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@manasil.in"
              required
            />
          </Field>

          <Field label="Password">
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </Field>

          <button type="submit" className="btn btn-primary" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
    </div>
  );
}
